const cssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/trustage-aa--wc.css`
const componentCssUrl = `${import.meta.env.VITE_CDN_ROOT}${import.meta.env.VITE_ASCEND_AWESOME_VERSION}/css/components/Property.css`;

// Template with both CDN and local Property CSS
const t = document.createElement('template')
t.innerHTML = `
<link href="${cssUrl}" rel="stylesheet" />
<link href="${componentCssUrl}" rel="stylesheet" />
`

// Template with just local Property CSS (for parent components that already include CDN CSS)
const tMinimal = document.createElement('template')
tMinimal.innerHTML = `
<link href="${componentCssUrl}" rel="stylesheet" />
`

const TemplatePropertyCompleteStyles = t
const TemplatePropertyMinimalStyles = tMinimal

export { TemplatePropertyCompleteStyles, TemplatePropertyMinimalStyles }